var barcodes = {};
export {
  barcodes as __exports
};
//# sourceMappingURL=index138.js.map
